module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_users_remoteEntry_mjs_f281a89f__;